import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MmpFlagComponentComponent } from "../mmp-flag-component/mmp-flag-component.component";

@Component({
  selector: "app-mmp-ai-summary",
  templateUrl: "./mmp-ai-summary.component.html",
  styleUrls: ["./mmp-ai-summary.component.scss"],
  standalone: true,
  imports: [CommonModule, MmpFlagComponentComponent],
})
export class MmpAiSummaryComponent {
  @Input() progressTagMsg!: string;
  @Input() progressTagClass!: string;
  @Input() progressTimeText!: string;
  @Input() progressTime!: string;
  @Input() aiSummaryContent!: string;
  @Input() courseCount!: number;
  @Input() flaggedCount!: number;
  @Input() confidenceScore!: number;
  @Input() notTransferForCredit!: number;
  @Input() transferForCredit!: number;
  @Input() currentTab!: string;
  @Input() courseMatched!: number;
  @Input() courseNotMatched!: number;
}
